// src/constants/index.js
// 78차 62차: isKoreanHoliday에 overrides 파라미터 추가 — 공휴일 자동차단 중 특정 날짜만
// 개별적으로 예외 처리(정상 영업)할 수 있게 함.
// 75차: GENRE_META/PLAN_COLORS 추가 — design_handoff_unlock 디자인 시스템 반영
import { COLORS } from './theme';

// 78차 45차: 실제 매장 등록 중 발견 — 드라마/감성 장르가 목록에 아예 없었고, 어드벤처는
// GENRE_META에만 있고(78차 38차 땜질) GENRES 본체엔 없어서 여러 화면의 장르 선택/필터
// 칩에서 고를 수 없었음. 셋 다 실제 방탈출 업계에서 흔히 쓰는 장르 태그로 확인 후 추가.
// 78차 51차: "체험형"(배우 출연/실사 세트 등 몰입형 공포체험 — 롯데월드 마도신당·귀담류)
// 추가했었음 — 80차 후속: theme.bookingFormat==='show'(체험형 공연, 정원제)라는 실제
// 예약 형식 축이 새로 생기면서 이름이 겹쳐 혼동을 준다는 지적으로 이 장르 태그는 삭제.
export const GENRES = [
  '공포', '추리', '미스터리', '판타지', '스릴러', '액션', '로맨스', '코미디', 'SF',
  '어드벤처', '드라마', '감성', '기타',
];

// 78차: claude.ai/design 프로젝트(DesignSync로 재조회) "장르 배지 세트" 섹션에 실제로는
// 11개 장르 전부 색이 지정돼 있었음(75차엔 공포/추리 2개만 있는 걸로 잘못 파악) — 이 앱
// 장르(GENRES)와 겹치는 8개(공포/추리/스릴러/액션/판타지/SF/코미디/로맨스)에 그대로 적용.
// 어드벤처/감성/드라마는 이 앱 장르 목록에 없어 미적용, 미스터리는 앱 자체 장르라 디자인엔
// 없지만 기존처럼 추리와 동일 취급, 기타는 디자인에도 없어 중립색 유지.
// 78차 38차: 테마 genre 필드는 실제로 GENRES 목록에 강제되는 드롭다운이 아니라 엑셀
// 일괄등록의 자유 텍스트 컬럼이라("장르" 컬럼에 뭐든 입력 가능), 실제 데이터에
// GENRES 밖의 값("어드벤처")이 이미 들어가 있어 en 표기가 빈 문자열로 나오던 버그 —
// GENRE_META에 추가.
export const GENRE_META = {
  공포:     { en: 'HORROR',   color: '#F0B8A8' },
  추리:     { en: 'MYSTERY',  color: '#BFD3F5' },
  미스터리: { en: 'MYSTERY',  color: '#BFD3F5' },
  판타지:   { en: 'FANTASY',  color: '#C4AEE8' },
  스릴러:   { en: 'THRILLER', color: '#E7A6C4' },
  액션:     { en: 'ACTION',   color: '#E9A98C' },
  어드벤처: { en: 'ADVENTURE', color: '#A8C99A' },
  로맨스:   { en: 'ROMANCE',  color: '#F0AEB8' },
  코미디:   { en: 'COMEDY',   color: '#EFD292' },
  SF:       { en: 'SF',       color: '#8FD3E0' },
  드라마:   { en: 'DRAMA',    color: '#C7A98F' },
  감성:     { en: 'EMOTIONAL', color: '#A9B8D9' },
  기타:     { en: 'ETC' },
};
// 78차 45차: 테마당 장르 2개까지 지원 — 저장 형식은 스키마 변경 없이 기존 genre(문자열)
// 필드 그대로 "공포/추리"처럼 "/"로 이어붙임(화면 대부분이 genre를 그냥 텍스트로 찍고
// 있어서 표시는 자동으로 해결됨 — 색상/영문 표기만 첫 번째 장르 기준으로 조회).
export const splitGenres = (genre) => String(genre || '').split('/').map(g => g.trim()).filter(Boolean);

export const getGenreMeta = (genre) => {
  const primary = splitGenres(genre)[0];
  const meta = GENRE_META[genre] || GENRE_META[primary];
  return { en: meta?.en || '', color: meta?.color || COLORS.textSec };
};

// 78차 39차: 난이도(easy/normal/hard/expert) 라벨+색상 매핑이 StoreDetailScreen.js/
// ThemeDetailScreen.js에 완전히 동일한 `difficultyLabel`/`difficultyColor` 함수로 각자
// 중복 정의돼 있었고, RecruitScreen.js(DIFFICULTY_LABELS)/BookingScreen.js(DIFFICULTY_OPTIONS)도
// 같은 매핑을 또 각자 정의 — 78차6차에 지적됐던 "매장 상세만 표기가 다르다"류 문제의
// 근본 원인이라 공용화(GENRE_META/getGenreMeta와 동일한 패턴).
export const DIFFICULTY_META = {
  easy:   { label: '쉬움',   color: COLORS.green },
  normal: { label: '보통',   color: COLORS.gold },
  hard:   { label: '어려움', color: COLORS.orange },
  expert: { label: '전문가', color: COLORS.red },
};
export const getDifficultyLabel = (d) => DIFFICULTY_META[d]?.label || d || '-';
export const getDifficultyColor = (d) => DIFFICULTY_META[d]?.color || COLORS.textMuted;

// 80차: 예약 형식 — 'room'(기본, 방탈출처럼 한 팀이 시간대를 통째로 전세) vs
// 'show'(체험형 공연처럼 여러 팀이 같은 회차 정원 안에서 동시 참여). GENRES의 "체험형"
// 태그(소재/연출 방식 태그, 배타적이지 않게 다른 장르와 함께 붙일 수 있음)와는 축이
// 다른 별개 필드라 라벨을 구분해서 명명(theme.bookingFormat, 기본값 'room' — 필드가
// 아예 없는 기존 테마 전부 room으로 간주되어 무영향).
export const BOOKING_FORMATS = {
  room: { label: '방탈출(전세)' },
  show: { label: '체험형 공연(정원제)' },
};
export const getBookingFormatLabel = (v) => BOOKING_FORMATS[v || 'room']?.label || BOOKING_FORMATS.room.label;

// 80차 후속: 체험형(show) 전용 — 한 회차를 우리 팀이 통째로 대관(단독)하는지, 다른 팀과
// 정원을 나눠 쓰는(합석) 일반 회차인지. 방탈출(room)은 구조상 항상 "단독"이라 뱃지 자체가
// 불필요(=이 값을 안 씀) — show 포맷에만 해당하는 선택 필드.
export const SEATING_TYPES = {
  shared:    { label: '합석' },
  exclusive: { label: '단독' },
};
export const getSeatingTypeLabel = (v) => SEATING_TYPES[v || 'shared']?.label || SEATING_TYPES.shared.label;

// 80차 후속: 체험형 공연은 "탈출 난이도" 개념이 없어 같은 4단계 enum(easy~expert)을
// theme.activityLevel로 재사용 — DifficultyGaugeDots 등 표시 컴포넌트는 그대로 두고
// 라벨/색만 다르게(DIFFICULTY_META와 동일 구조).
export const ACTIVITY_META = {
  easy:   { label: '여유로움', color: COLORS.green },
  normal: { label: '보통',     color: COLORS.gold },
  hard:   { label: '활동적',   color: COLORS.orange },
  expert: { label: '격렬함',   color: COLORS.red },
};
export const getActivityLabel = (d) => ACTIVITY_META[d]?.label || d || '-';
export const getActivityColor = (d) => ACTIVITY_META[d]?.color || COLORS.textMuted;

// 80차 후속: 체험형 공연 테마를 "체험형"으로 처음 전환할 때(내용이 비어있을 때만) 채우는
// 기본 유의사항/환불정책 — 관리자가 그대로 두거나 수정 가능.
export const SHOW_DEFAULT_NOTICES =
  '공연 시작 10분 전까지 도착해주세요.\n최소 2인 이상 모이지 않으면 공연이 취소될 수 있습니다.\n임산부, 유아 동반, 심장질환자는 참여가 제한될 수 있습니다.';
export const SHOW_DEFAULT_REFUND_POLICY =
  '공연 3일 전까지 취소 시 전액 환불됩니다. 이후 취소·노쇼 시 환불이 제한될 수 있습니다. 정확한 환불 규정은 매장에 문의해주세요.';

// 78차 48차: 공휴일 자동 예약 차단(테마별 blockHolidays 토글, 기본 ON) — 정부 공휴일 API
// 연동 없이(네트워크 의존/키 관리 부담 대비 실효 낮음) 확정된 날짜만 하드코딩.
// ponytail: 설/추석처럼 매년 날짜가 바뀌는 공휴일이 섞여 있어 해가 바뀌면 갱신 필요 —
// 다음 연도가 다가오면 이 Set에 그 해 날짜를 추가할 것. 근로자의 날(5/1)은 관공서
// 공휴일이 아니라(근로기준법상 유급휴일) 제외.
export const KOREAN_HOLIDAYS = new Set([
  // 2026
  '2026-01-01', // 신정
  '2026-02-16', '2026-02-17', '2026-02-18', // 설 연휴
  '2026-03-01', // 삼일절
  '2026-03-02', // 삼일절 대체공휴일
  '2026-05-05', // 어린이날
  '2026-05-24', // 부처님오신날
  '2026-05-25', // 대체공휴일
  '2026-06-03', // 전국동시지방선거일(임시공휴일)
  '2026-06-06', // 현충일
  '2026-07-17', // 제헌절(2026년 재지정)
  '2026-08-15', // 광복절
  '2026-08-17', // 대체공휴일
  '2026-09-24', '2026-09-25', '2026-09-26', // 추석 연휴
  '2026-10-03', // 개천절
  '2026-10-05', // 대체공휴일
  '2026-10-09', // 한글날
  '2026-12-25', // 크리스마스
]);
// 78차 62차: overrides(theme.holidayOverrides) — 매장관리자가 특정 공휴일 하나만
// "이 날은 정상 영업"으로 예외 처리한 날짜 목록. 전체 공휴일 자동차단은 그대로 켜둔 채
// 개별 날짜만 해제할 수 있어야 한다는 요청 반영.
export const isKoreanHoliday = (dateStr, overrides = []) =>
  KOREAN_HOLIDAYS.has(dateStr) && !overrides.includes(dateStr);

// 80차 계속: [지역 목록 확장] 광역시 7곳뿐이라 그 외 지역(강원/충청/전라/경상/제주 등)
// 매장은 전부 "기타"로만 묶여 지역 필터/모집글 지역선택이 무의미했음(모집탭 작성
// 편의성 개선 요청으로 발견) — 나머지 도 단위 지역 10곳 추가.
export const REGIONS = [
  '서울', '경기', '인천', '부산', '대구', '광주', '대전', '울산', '세종',
  '강원', '충북', '충남', '전북', '전남', '경북', '경남', '제주', '기타',
];

// 80차 계속: [상세지역 대폭 확장] 서울이 8개뿐이라 실제 방탈출 밀집 지역(성수/왕십리/
// 노원/신림/잠실/합정 등)이 전부 빠져있어 "상세지역 없음" 취급됐음 — 이번 세션 매장
// 아웃리치 조사(19곳+홍대 방문 전체)에서 실제 확인된 지역들 위주로 재작성, 나머지
// 광역시/도는 도청소재지·주요 도시 위주로 신규 추가.
export const SUB_REGIONS = {
  서울: [
    '강남', '홍대', '신촌', '건대', '혜화', '이태원', '종로', '잠실',
    '왕십리', '성수', '노원', '신림', '사당', '합정', '상수', '여의도',
    '목동', '서울대입구', '명동', '동대문', '청량리', '강서', '구로', '압구정',
    '기타',
  ],
  경기: ['수원', '성남(분당/판교)', '고양', '용인', '부천', '안양', '김포', '평택', '기타'],
  인천: ['부평', '송도', '구월', '기타'],
  부산: ['서면', '해운대', '남포동', '기타'],
  대구: ['동성로', '기타'],
  광주: ['충장로', '기타'],
  대전: ['둔산', '기타'],
  울산: ['삼산', '기타'],
  세종: ['기타'],
  강원: ['춘천', '강릉', '원주', '기타'],
  충북: ['청주', '기타'],
  충남: ['천안', '아산', '기타'],
  전북: ['전주', '기타'],
  전남: ['여수', '순천', '목포', '기타'],
  경북: ['포항', '경주', '구미', '기타'],
  경남: ['창원', '김해', '진주', '기타'],
  제주: ['제주시', '서귀포', '기타'],
  기타: ['기타'],
};

// ─── 매장 plan (노출 등급) 2단계 체계 + 매장관리자 기능 애드온 ──────────
// 80차 후속: 대형 프랜차이즈 영업 결과 — 이 세그먼트는 예약관리·통계·정산 같은
// "매장관리자 기능"을 거의 안 쓴다(이미 자체 시스템 보유)는 게 확인됨. 기존 3단계
// (BASIC/STANDARD/PREMIUM)는 "노출"과 "운영도구"를 한 사다리에 묶어놔서, 그 세그먼트가
// 원하는 건 최상위(PREMIUM)에만 있고 중간 단계(STANDARD)는 아무도 안 맞는 구조였음
// (자세한 배경은 CLAUDE.md 80차 "요금제" 관련 기록 참고).
//
// 새 구조 — "노출"(plan)과 "운영도구"(opsAddon)를 완전히 독립된 두 축으로 분리:
//   - plan(STANDARD/PREMIUM 2단계): 노출 수준만 결정 — STANDARD=앱 노출, PREMIUM=+PICK 테마 노출
//   - opsAddon(boolean, plan과 무관하게 매장별로 켜고 끄는 항목): 예약관리·통계·정산
//     기능 — 필요한 매장만 월 15,000원 추가(OPS_ADDON_FEE_SERVER와 반드시 동기화).
//     STANDARD/PREMIUM 어느 쪽이든 이 애드온이 없으면 매장관리자 화면의 홈/통계 탭과
//     "월별 정산 요약" 카드는 안 보임(예약 확인·매장설정은 애드온과 무관하게 항상 이용 가능).
// 표시: 애드온이 켜진 매장은 "STANDARD+"/"PREMIUM+"처럼 뒤에 +를 붙여 구분
// (getPlanBadgeLabel 참고).
//
// 이름 재사용에 유의 — "STANDARD"라는 이름은 유지되지만 의미가 완전히 바뀌었다(구버전
// STANDARD는 매장관리자 기능이 번들돼 있었으나, 신버전 STANDARD는 순수 노출만 의미).
//
// 하위호환: 기존 3단계 데이터(basic/standard/premium/free/boost)는 LEGACY_PLAN_MAP으로
// 정규화하되, opsAddon 필드가 아직 없는(마이그레이션 전) 문서는 deriveLegacyOpsAddon()로
// 구버전 plan 값 기준 안전하게 유추한다(실제 운영 매장은 scripts로 opsAddon 필드를 명시
// 저장하는 일회성 마이그레이션을 거쳤음 — 이 유추는 어디까지나 방어적 폴백).
export const PLAN_TIERS = ['standard', 'premium'];

export const PLAN_LABELS = {
  standard: 'STANDARD',
  premium:  'PREMIUM',
};

// 80차 후속: 요금 재구성(사용자 확정) — STANDARD/PREMIUM 둘 다 순수 노출 등급 가격으로
// 재산정, 매장관리자 기능(운영도구)은 OPS_ADDON_FEE로 분리.
export const PLAN_PRICES = {
  standard: 19900,
  premium:  35900,
};

// 80차 후속: 매장관리자 기능(예약관리 통계·정산 등) — plan과 무관하게 필요한 매장만
// 켜는 월 추가 요금. functions/index.js의 OPS_ADDON_FEE_SERVER와 반드시 동기화할 것.
export const OPS_ADDON_FEE = 15000;

// 78차 64차: 최초 계약 시 등급별 기본 할인율(planDiscountRate) — 매장 대상 영업 시
// 총괄관리자가 개별적으로 안내하는 재량 사항이라 구체적인 값의 근거는 별도로 문서화하지
// 않음(값 자체는 아래 참고). 78차 47차의 "계약일 기준 자동 만료" 방식은 경직/복잡하다는
// 이유로 이미 한 번 폐지된 바 있어, 다시 자동화하지 않고 매장을 이 등급으로 처음
// 설정하는 시점(신규 등록/플랜 변경)에 이 값을 기본값으로만 채워준다 — 이후 갱신·조정은
// 총괄관리자가 여전히 수동으로 함(자동 만료 없음). 구버전 이름 그대로 값 유지(80차 후속
// 재구성은 구조만 바꿨을 뿐 할인율 재량 자체는 총괄관리자 몫이라 임의로 새 값을 만들지 않음).
export const PLAN_DEFAULT_DISCOUNT_RATE = {
  standard: 30,
  premium:  50,
};

// 75차: 플랜 라인 컬러 — design_handoff_unlock 디자인 시스템 값 그대로
export const PLAN_COLORS = {
  standard: COLORS.blue,
  premium:  COLORS.gold,
};

// 구버전 값 → 신버전 값 매핑 (읽기 시 정규화 전용, 쓰기에는 사용하지 않음)
// 80차 후속: 구버전 basic/standard(둘 다 PICK 없음)는 신버전 standard로, 구버전
// premium/boost(둘 다 PICK 있음)는 신버전 premium으로 통합.
const LEGACY_PLAN_MAP = {
  free:     'standard',
  basic:    'standard',
  standard: 'standard',
  premium:  'premium',
  boost:    'premium',
};

// 저장된 plan 값을 2단계 체계로 정규화 (구버전 'basic'/'free'/'boost' 등도 안전하게 처리)
export const normalizePlan = (plan) => {
  if (PLAN_TIERS.includes(plan)) return plan;
  if (LEGACY_PLAN_MAP[plan]) return LEGACY_PLAN_MAP[plan];
  return 'standard';
};

// 80차 후속: opsAddon 필드가 아직 없는 구버전 문서에서만 쓰는 방어적 폴백 — 구버전
// standard/premium/boost는 매장관리자 기능이 plan에 번들돼 있었으므로 true로 유추.
// (실제 운영 매장은 마이그레이션 스크립트로 opsAddon을 명시 저장했으므로 이 함수는
// 그 스크립트를 못 거친 데이터를 위한 안전망일 뿐, 정상 경로에서는 store.opsAddon을
// 직접 읽어야 한다 — feeService.js의 hasOpsAddon 참고.)
export const deriveLegacyOpsAddon = (rawPlan) => ['standard', 'premium', 'boost'].includes(rawPlan);

// "STANDARD"/"PREMIUM" 라벨에 매장관리자 기능 애드온 여부를 "+"로 표시 — 총관리자/
// 매장관리자 화면 여러 곳에서 재사용(getBranchPlan/getEffectivePlan으로 이미 구한 plan
// 값과, hasOpsAddon(feeService.js)으로 구한 boolean을 그대로 넘기면 됨).
export const getPlanBadgeLabel = (plan, opsAddon) =>
  PLAN_LABELS[normalizePlan(plan)] + (opsAddon ? '+' : '');

// 매장의 plan이 최소 requiredTier 이상인지 확인 (계층적 게이트용, 지금은 2단계라
// 사실상 "PREMIUM인지 아닌지"만 구분하지만 3단계였던 과거처럼 그대로 재사용 가능)
// 예: planAtLeast(store.plan, 'premium') → premium 매장(구 boost 포함)에서 true
export const planAtLeast = (plan, requiredTier) => {
  const current  = PLAN_TIERS.indexOf(normalizePlan(plan));
  const required = PLAN_TIERS.indexOf(requiredTier);
  if (current < 0 || required < 0) return false;
  return current >= required;
};

// 78차 16차: PICK 테마 등록의 자유입력 "설명"을 없애고 고정 태그 중 하나를 고르게 함
// (매장마다 문구가 제각각이라 카드 배지로 쓰기 어려웠음). 78차 58차: "인기 급상승"/
// "얼리버드 할인"/"사장님 추천" 등 판촉성 문구는 고객 입장에서 신빙성이 없다는 지적으로,
// 테마의 실제 특징을 나타내는 배지 위주로 교체 + 최대 3개 다중선택 + 직접입력(5자 이내)
// 지원으로 확장 — 그래서 value/label 구분 없이 "표시될 문구 그대로"만 저장하는
// 문자열 배열로 단순화(직접입력 배지와 저장 형식을 통일하기 위함).
// 80차 후속: 체험형(공연형) PICK 등록이 생기면서, 방탈출 전용 어휘("문제 많음"/"고난도"/
// "장치 화려" 등)를 체험형에도 그대로 노출하는 게 안 맞아 방식별로 목록을 분리.
export const PICK_HIGHLIGHTS_ROOM = [
  '신규 오픈', '리뉴얼 오픈', '문제 많음', '문제 적음', '고난도', '초보 추천',
  'BGM 맛집', '스토리 몰입', '장치 화려', '인생네컷', '2인 추천', '3인 추천',
  '4인 추천', '5인 추천',
];
export const PICK_HIGHLIGHTS_SHOW = [
  '신규 오픈', '리뉴얼 오픈', '심야 회차', '배우 인터랙션 多', '몰입도 높음',
  'BGM 맛집', '스토리 몰입', '연출 화려', '인생네컷', '매진 임박', '단체 관람 추천',
  '1인 관람 가능', '가족 추천',
];
export const getPickHighlights = (bookingFormat) => bookingFormat === 'show' ? PICK_HIGHLIGHTS_SHOW : PICK_HIGHLIGHTS_ROOM;
export const PICK_HIGHLIGHT_MAX = 3;
export const PICK_HIGHLIGHT_CUSTOM_MAX_LEN = 5;

// 78차 59차: 공지사항 작성 시 "공지" 배지 옆에 붙는 대분류 배지(선택, 단일선택).
// 지금까지 공지/소식/혜택 3개 타입 배지뿐이라 "무엇에 관한 공지인지"(신규매장 소식인지
// 휴업 안내인지 등)를 목록에서 구분할 수 없었음 — EventsScreen.js(작성 폼+카드 배지)에서 사용.
export const NOTICE_CATEGORIES = [
  '신규 매장', '테마 소식', '휴업 안내', '정책 변경', '시스템 점검', '크루 이벤트', '이용 안내',
];

// 78차 35차: 문의 작성 시 카테고리 선택 — 지금까지 제목/내용만 자유입력이라 총괄관리자가
// 목록만 보고는 문의 성격을 알 수 없었음. targetType('app'/'store')별로 실제 자주 오는
// 문의 성격에 맞춰 다른 목록을 둠. WriteInquiryScreen.js(작성)/InquiriesScreen.js·
// MyInquiriesScreen.js(목록 배지) 공유.
export const INQUIRY_CATEGORIES = {
  app: [
    { value: 'billing',    label: '요금' },
    { value: 'app_bug',    label: '앱 오류' },
    { value: 'account',    label: '계정' },
    { value: 'suggestion', label: '제안' },
    // 80차 계속: 홈/예약탭 하단 "매장 사장님이신가요? 제휴 문의하기" 링크 전용 카테고리 —
    // 기존 '제안'은 일반 고객 피드백 성격이라 매장 제휴 문의를 구분해서 받을 창구가 없었음.
    { value: 'partnership', label: '매장 제휴' },
    // 테마 추가/수정/삭제는 매장관리자가 직접 반영할 수 없고 총괄관리자만 가능한 작업이라
    // "앱 문의하기"(총괄관리자 전담 창구) 쪽에 둠 — 매장관리자 발신일 때만 노출(아래
    // WriteInquiryScreen.js에서 senderRole로 필터링). 선택 시 제목/테마 상세 입력 폼
    // (난이도·장르·플레이타임·이미지 등)을 자동으로 구성해준다.
    { value: 'theme_edit',   label: '테마수정' },
    { value: 'theme_add',    label: '테마추가' },
    { value: 'theme_delete', label: '테마삭제' },
    { value: 'etc',        label: '기타' },
  ],
  store: [
    { value: 'reservation', label: '예약' },
    { value: 'payment',     label: '결제' },
    { value: 'store_info',  label: '매장 정보' },
    { value: 'complaint',   label: '불편사항' },
    { value: 'etc',         label: '기타' },
  ],
};
// 위 3개 카테고리 선택 시 WriteInquiryScreen.js가 구조화된 테마 정보 입력 폼으로 전환.
export const THEME_REQUEST_CATEGORIES = ['theme_edit', 'theme_add', 'theme_delete'];
export const getInquiryCategoryLabel = (targetType, value) =>
  (INQUIRY_CATEGORIES[targetType] || []).find(c => c.value === value)?.label || null;